import { render, staticRenderFns } from "./NewElection.vue?vue&type=template&id=add0fb1a"
import script from "./NewElection.vue?vue&type=script&lang=ts"
export * from "./NewElection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports